import {take, range, partial} from 'lodash'
import moment from 'moment'
import React from 'react'
import Text from 'react-text'
import {useDrop} from 'react-dnd'
import {Consumer} from '../../context'
import {rescheduleEvent} from '../../context/post'
import Toolbar, {changeView} from './toolbar'
import Filters from './filters'
import Label from '../label'
import Event from './event'
import './month.styl'

const minEventHeight = 110
const minEventWidth = 130

const dayTitleHeight = 28
const eventHeight = 28
const viewMoreHeight = 20
const horizontalMargin = 40 
const verticalMargin = 300

function Day (props) {
  const {date, daySize, goToDay} = props
  const day = moment(date).format('YYYY-MM-DD')
  const isToday = moment(date).isSame(new Date(), 'day')
  const className=`day ${isToday ? 'current' : ''}`
  const displayCount = Math.floor((daySize.height - dayTitleHeight - viewMoreHeight) / eventHeight)
  const [collectedProps, drop] = useDrop({
    accept: 'event',
    canDrop: () => {
      return moment(date).isSameOrAfter(new Date(), 'day')
    },
    drop: ({id}) => {
      const event = props.context.events.find(e => e.id == id)
      if (event) {
        const finish = moment(date).startOf('day').add(event.duration, 'days')
        rescheduleEvent(id, date, finish).then(() => {
          const eventUpdates = props.context.eventUpdates + 1
          props.context.setState({eventUpdates})
        })
      }
    }
  })
  return (<Consumer>{ context => {
    const events = context.eventsByDay[day] || []
    return (
      <div
        ref={drop}
        className={className}
        style={{
          minWidth: daySize.width,
          maxWidth: daySize.width
        }}
        onClick={() => goToDay({start: day, end: day})}
      >
        <div className="title">
          {date.format('D')}
        </div>
        <div className="events">
          {take(events, displayCount).map((props, i) => (<Event key={i} {...props}/>))}
        </div>
        <div style={{flexGrow: 1}} />
        {events.length > displayCount && (
          <div className="view-more">
            <Text id="view-more" /> {events.length - displayCount}...
          </div>
        )}
      </div>
    )
  }}</Consumer>)
}

function Week(props) {
  const {start, daySize, context, goToDay} = props 
  const days = range(7)
    .map(d => ({goToDay, context, daySize, date: moment(start).add(d, 'days')}))
    .map((props,i) => (<Day key={i} {...props}/>))
  return (
    <div className="week">
      {days}
    </div>
  )
}

function Header(props) {
  const {date, daySize} = props
  return (
    <div
      className="header week"
      style={{flexGrow: 1}}
    >
      {date.format('ddd')}
   </div>)
}



export default function MonthView (props) {

  const {date} = props
  const start = date().startOf('month').startOf('week')
  const end = date().endOf('month').endOf('week')
  const weekCount = Math.ceil(end.diff(start, 'days') / 7)

  return (<Consumer>{ context => {
    const {sizes} = context
    const goToDay = partial(changeView(context), 'day')
    const daySize = {
      width: Math.max(minEventWidth, Math.round((sizes.width - horizontalMargin - 6) / 7)),
      height: Math.max(minEventHeight, Math.round((sizes.height - verticalMargin) / weekCount))
    }
    const weeks = range(weekCount)
      .map(w => ({goToDay, context, start: moment(start).add(w, 'weeks'), daySize}))
      .map((props,i) => (<Week key={i} {...props}/>))

    const headers = range(7)
      .map(d => ({date: moment(start).add(d, 'days'), daySize}))
      .map((props,i) => (<Header key={i} {...props}/>))

    return (
      <div className="calendar month view" style={{width: sizes.width - horizontalMargin + 6}}>
        <Toolbar {...props} />
        <div className="calendar">
          <Filters />
          <div className="headers">
            {headers}
          </div>
          <div className="weeks">
            {weeks}
          </div>
        </div>
      </div>
    )}}</Consumer>)
}
